var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "fixed width-100 z-99" },
          [
            _c(
              "van-tabs",
              {
                model: {
                  value: _vm.tabIndex,
                  callback: function ($$v) {
                    _vm.tabIndex = $$v
                  },
                  expression: "tabIndex",
                },
              },
              [
                _c("van-tab", { attrs: { title: "发起提交" } }),
                _c("van-tab", { attrs: { title: "查看数据" } }),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "h-98" }),
        _c("list", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabIndex === 1,
              expression: "tabIndex === 1",
            },
          ],
          ref: "list",
          on: { change: _vm.listChange },
        }),
        _c("addOrUpdate", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabIndex === 0,
              expression: "tabIndex === 0",
            },
          ],
          ref: "addOrUpdate",
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }